export const SET_ACTIVITIES = 'SET_ACTIVITIES';
export const SET_ACTIVITY = 'SET_ACTIVITY';
export const ADD_ACTIVITY = 'ADD_ACTIVITY';
export const UPDATE_ACTIVITY = 'UPDATE_ACTIVITY';
export const REMOVE_ACTIVITY = 'REMOVE_ACTIVITY';
export const CLEAR_ACTIVITY = 'CLEAR_ACTIVITY';
export const CLEAR_ACTIVITIES = 'CLEAR_ACTIVITIES';
